import { useEffect, useRef, useState } from 'react';

/**
 * 값이 바뀔 때마다 1씩 증가하는 카운터를 돌려준다(#23 마이크로인터랙션).
 *
 * 반환값을 렌더 요소의 `key`로 쓰면 값이 갱신될 때마다 그 요소가 다시 마운트돼
 * `.flash-pulse` CSS 애니메이션이 재생된다 — setState/타이머 없이 하이라이트 펄스를
 * 트리거하는 가장 가벼운 방법(성능 우선). 초기 마운트에서는 펄스가 일어나지 않는다.
 */
export const useFlashOnChange = (value: unknown): number => {
  const [count, setCount] = useState(0);
  const prev = useRef(value);

  useEffect(() => {
    if (prev.current !== value) {
      prev.current = value;
      setCount((c) => c + 1);
    }
  }, [value]);

  return count;
};
